import { isValidVRN } from '@wrisk/ui-components'

import { required } from '../helpers'
import { ValidationFunctions } from '../types'

export const vehicleRegistration: ValidationFunctions = {
  _self: {
    required,
    format: isValidVRN,
  },
}
